import { render, staticRenderFns } from "./Monitor.vue?vue&type=template&id=52e35d91&scoped=true&"
import script from "./Monitor.vue?vue&type=script&lang=js&"
export * from "./Monitor.vue?vue&type=script&lang=js&"
import style0 from "./Monitor.vue?vue&type=style&index=0&module=true&lang=css&"
import style1 from "./Monitor.vue?vue&type=style&index=1&id=52e35d91&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "52e35d91",
  null
  
)

export default component.exports